function windowConfig(varName) {
  if (window.config) {
    return window.config[varName];
  } else {
    return undefined;
  }
}

export default {
  MK_API:
    windowConfig("VITE_MK_API") ||
    import.meta.env.VITE_MK_API ||
    "https://booking-back.dev.kodland.org/",
  MK_BACKOFFICE_API:
    windowConfig("VITE_MK_BACKOFFICE_API") ||
    import.meta.env.VITE_MK_BACKOFFICE_API ||
    "https://backoffice.test.kodland.org/api/v1/",
  DOWNTIME_ENABLED:
    windowConfig("VITE_DOWNTIME_ENABLED") || import.meta.env.VITE_DOWNTIME_ENABLED || false,
};
